var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#769DFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9715 21.3365H52.0285C53.5907 21.3365 54.8571 22.6497 54.8571 24.2696V47.7336C54.8571 49.3535 53.5907 50.6666 52.0285 50.6666H19.9715C18.4093 50.6666 17.143 49.3535 17.143 47.7336V24.2696C17.143 22.6497 18.4093 21.3365 19.9715 21.3365Z",
    fill: "#9EBAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2027 31.9169C37.5744 31.9304 38.8945 32.4603 39.9176 33.4078L54.8571 47.9995C54.8216 48.7414 54.504 49.4384 53.9738 49.9378C53.4436 50.4372 52.744 50.6982 52.0285 50.6637H19.9715C19.2563 50.6969 18.5575 50.4355 18.0275 49.9363C17.4976 49.4372 17.1796 48.7409 17.143 47.9995L32.4502 33.4029C32.4502 33.4029 33.6618 31.9169 36.2027 31.9169Z",
    fill: "#89A9FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.802 40.0832C34.4292 40.0715 33.1079 39.5395 32.0872 38.5874L17.143 24.0006C17.1796 23.2592 17.4976 22.5629 18.0275 22.0638C18.5575 21.5647 19.2563 21.3032 19.9715 21.3364H52.0285C52.744 21.3019 53.4436 21.5629 53.9738 22.0623C54.504 22.5617 54.8216 23.2587 54.8571 24.0006L39.5546 38.5923C39.5546 38.5923 38.343 40.0832 35.802 40.0832Z",
    fill: "#BFD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.0a371b0da49d6ccdcc3f4bb32a7ac8f5.svg";
export { ForwardRef as ReactComponent };